import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { CalendarComponent } from '../../calendar.component';
import { CalendarSettingModel } from '../../calendar.model';

@Component({
  selector: 'pivot-choose-date',
  templateUrl: './choose-date.component.html',
  styleUrls: ['./choose-date.component.scss'],
})
export class ChooseDateComponent {
  @Input() date: Date = new Date();
  @Input() addDays = 0;
  @Input() readOnly = false;
  @Input() isDisplayWrapper = false;
  @Input() dateRangeStart: Date;
  @Input() dateRangeEnd: Date;
  @Input() showDateOfWeek = false;
  @Input() notSetText = '未設定';
  @Input() isEraFormatJpDate = false;
  @Output() dateChange = new EventEmitter<Date>();

  constructor(public dialog: MatDialog) { }

  calendarOpen() {
    if (!this.readOnly) {
      const dialogData = new CalendarSettingModel(
        this.date,
        '',
        false,
        this.dateRangeStart,
        this.dateRangeEnd,
      );

      const dialogRef = this.dialog.open(CalendarComponent, {
        data: dialogData,
        disableClose: true,
        panelClass: 'calendar-dialog',
      });
      dialogRef.afterClosed().subscribe(res => {
        if (res) {
          this.date = res.date;
          this.dateChange.emit(this.date);
        }
      });
    }
  }
}
